/* eslint-disable max-len */
// Node Module Imports
import React from 'react'

import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Component Imports
import { colors } from '../../style/design-system'
import ChevronBackgroundTwoTone from '../elements/ChevronBackgroundTwoTone'

// Style Imports

const AccreditedYouBet = ({ className }) => (
  <div className={`${className}`}>
    <ChevronBackgroundTwoTone
      backgroundColor={colors.dev.gray.b()}
      chevron={{ color: colors.dev.green.e(), display: true }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1 text-center">
            <div className="h1 white">Accredited? Yes.</div>
            <p className="lead white my-7 text-center">
              Ultimate Medical Academy maintains the following accreditations:
            </p>
            <p className="lead white my-7 text-center">
              UMA is institutionally accredited by the Accrediting Bureau of Health Education Schools (abhes.org), a
              national accrediting agency that is recognized by the U.S. Secretary of Education.
            </p>
            <p className="lead white my-7 text-center">
              UMA’s Health Information Management program is programmatically accredited by the Commission on
              Accreditation for Health Informatics and Information Management Education (CAHIIM).
            </p>
            <p className="lead white my-7 text-center">
              Ultimate Medical Academy’s accreditation for the Health Information Management associate degree program
              has been reaffirmed through 2033-2034.
            </p>
            <p className="white my-7 text-center">
              <small>
                All inquiries about the program’s accreditation status should be directed by mail to CAHIIM, 200 East
                Randolph Street, Suite 5100, Chicago, IL 60601; by phone at{' '}
                <a href="tel:3122353255" className="white">
                  312-235-3255
                </a>
                ; or by{' '}
                <span className="nowrap">
                  email at{' '}
                  <a href="mailto:info@cahiim.org" className="white">
                    info@cahiim.org
                  </a>
                  .
                </span>
              </small>
            </p>
            <div className="h1 white">Licensed in Florida? Yes.</div>
            <p className="lead white my-7 text-center">
              Ultimate Medical Academy is licensed by the Commission for Independent Education (CIE), Florida Department
              of Education.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 d-flex justify-content-center align-items-center flex-wrap">
            <div className="p-7">
              <StaticImage
                src="../../assets/images/external/accreditation/abhes-white.png"
                alt="Accrediting Bureau of Health Education Schools"
                placeholder="none"
              />
            </div>
            <div className="p-7">
              <StaticImage
                src="../../assets/images/external/accreditation/fde-white.png"
                alt="Florida Department of Education"
                placeholder="none"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-10 offset-lg-1 text-center">
            <Link className="btn btn-outline-white" to="/about/accreditation/">
              Learn More&nbsp;&gt;
            </Link>
          </div>
        </div>
      </div>
    </ChevronBackgroundTwoTone>
  </div>
)

export default styled(AccreditedYouBet)`
  .btn-outline-white {
    color: #fff;
    &:hover {
      color: #000;
    }
  }
`

AccreditedYouBet.propTypes = {
  className: PropTypes.string,
}

AccreditedYouBet.defaultProps = {
  className: '',
}
